import { FilterGroupRequest, FilterRequestMap } from 'components/filter/types';

enum QuickBooksTransactionSyncStatus {
    ReadyToSync = 'ready_to_sync',
    DoNotSync = 'do_not_sync',
    Synced = 'synced',
    BeforeHistoricalDate = 'before_historical_date',
    Issues = 'issues',
    Syncing = 'syncing',
}

const QUICKBOOKS_SYNC_STATUS_MAP: Record<QuickBooksTransactionSyncStatus, string> = {
    ready_to_sync: 'Ready to sync',
    do_not_sync: 'Do not sync',
    synced: 'Synced',
    before_historical_date: 'Before historical date',
    issues: 'Sync issue',
    syncing: 'Syncing',
};

enum QuickBooksCustomerLookup {
    FirstNameLastName = 'type1',
    LastNameFirstName = 'type2',
    LastNameCommaFirstName = 'type3',
}

const READY_TO_SYNC_FILTER: FilterGroupRequest<FilterRequestMap>[] = [
    {
        children: [
            {
                type: 'and',
                children: {
                    quickBooksTransactionStatus: [
                        {
                            value: ['ready_to_sync'],
                            operator: '=',
                            type: 'and',
                        },
                    ],
                },
            },
        ],
        type: 'and',
    },
];

export {
    QUICKBOOKS_SYNC_STATUS_MAP,
    READY_TO_SYNC_FILTER,
    QuickBooksCustomerLookup,
    QuickBooksTransactionSyncStatus,
};
